import React from 'react';
import CustomDialog from '../../atoms/CustomDialog/CustomDialogAtom';

export interface DialogWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  header: React.ReactNode; // Dialog header (e.g. a search-input-headed command palette)
  visible: boolean; // Visibility state
  onHide: () => void; // Close callback
  children: React.ReactNode; // Content inside the dialog
  style?: React.CSSProperties; // Optional: Custom styles
  className?: string; // Optional: Custom class for additional styling
}

const DialogWrapper: React.FC<DialogWrapperProps> = ({
  header,
  visible,
  onHide,
  children,
  style,
  className = '', // Default to empty string if not provided
  ...restProps // Catch all other props
}) => {
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { ...restProps });
    }
    return child;
  });

  return (
    <CustomDialog header={header} visible={visible} onHide={onHide} style={style} className={`${className}`} >
      {childrenWithProps}
    </CustomDialog>
  );
};

export default DialogWrapper;
